import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ["MergeCustomerModal", "SendMerchModal", "CustomerSearchInput", "CustomerSearchResults"]

  get customerId() {
    return this.data.get('customerId')
  }

  onOrderClick(e) {
    e.preventDefault()

    const url = e.currentTarget.dataset.url
    const request = new FetchRequest('get', url, { responseKind: 'turbo-stream' })
    request.perform()

    window.history.replaceState('', '', url)
  }

  onCreateLeadClick(e) {
    e.preventDefault()

    e.currentTarget.disabled = true
    e.currentTarget.innerHTML = "Creating..."

    const url = e.currentTarget.dataset.url
    const request = new FetchRequest('get', url, { responseKind: 'html', redirect: 'follow' })
    request.perform()
  }

  onMergeClick(e) {
    e.preventDefault()
    this.MergeCustomerModalTarget.classList.remove('hidden')
  }

  onCancelMergeClick(e) {
    e.preventDefault()
    this.MergeCustomerModalTarget.classList.add('hidden')
  }

  onSendMerchClick(e) {
    e.preventDefault()
    this.SendMerchModalTarget.classList.remove('hidden')
  }

  onCancelSendMerchClick(e) {
    e.preventDefault()
    this.SendMerchModalTarget.classList.add('hidden')
  }

  searchCustomers(e) {
    e.preventDefault()
    const query = this.CustomerSearchInputTarget.value
    const url = `/admin/customers/search?query=${encodeURIComponent(query)}&format=json`

    const request = new FetchRequest('get', url, { responseKind: 'json' })
    request.perform()
      .then(response => response.json)
      .then(customers => {
        customers = customers.filter(customer => parseInt(customer.id) !== parseInt(this.customerId)) // filter out the current customer

        let searchResultsHTML = ''
        if (customers.length === 0) {
          searchResultsHTML = `<p>No customers found.</p>`
        } else {
          searchResultsHTML = customers.map(customer => `
            <div class="border-t py-2">
              <div class="font-bold">${customer.full_name}</div>
              <div>${customer.email}</div>
              <div>${customer.phone_number}</div>
              <div>${customer.address}</div>
              <div class="text-gray-500">Last Order Date: ${customer.most_recent_order_date || 'N/A'}</div>
              <button data-action="click->order-show#selectCustomer" data-customer-id="${customer.id}" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded mt-2">Select</button>
            </div>
          `).join('')
        }
        this.CustomerSearchResultsTarget.innerHTML = searchResultsHTML
      })
  }

  selectCustomer(e) {
    e.preventDefault()

    const targetCustomerId = e.currentTarget.dataset.customerId
    const url = `/admin/customers/${this.customerId}/merge_customers`

    const headers = new Headers({'Content-Type': 'application/json'})

    const body = JSON.stringify({ target_customer_id: targetCustomerId })

    const request = new FetchRequest('post', url, { responseKind: 'html', headers: headers, body: body })
    request.perform().then(response => {
      if (response.ok) {
        const redirectUrl = response.headers.get('Location')
        window.location.href = redirectUrl
      } else {
        // Handle errors if needed
        console.error('Error merging customers:', response.statusText)
      }
    })

    this.MergeCustomerModalTarget.classList.add('hidden')
  }
}